import { render, staticRenderFns } from "./leavemsg.vue?vue&type=template&id=29e53706&scoped=true&"
import script from "./leavemsg.vue?vue&type=script&lang=js&"
export * from "./leavemsg.vue?vue&type=script&lang=js&"
import style0 from "./leavemsg.vue?vue&type=style&index=0&id=29e53706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e53706",
  null
  
)

export default component.exports